// extracted by mini-css-extract-plugin
export default {"productrolesContainter":"ProductsPerProjectRoles_productrolesContainter__dQWRn"};